
import { Component, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { IdleTimeOutModel } from './idletimeout.model';
import { Observable, Subscription } from 'rxjs/Rx';
import { CommonService } from '../../shared/service/shared.service';
import { SharedModel } from '../../shared/models/shared.model';

@Component({
    selector: 'idleTimeOut-modal',
    templateUrl: './idletimeout.component.html'
})

export class IdleTimeOutComponent extends SiriusBaseComponent<IdleTimeOutModel> implements OnDestroy {
    @Input() hasTimeOut: boolean;
    @Input() logOutTimeRunOut: boolean;
    @Input() counter: number; 
    @Input() errorText: string;
    @Input() errorTitle: string;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onClickLogout: EventEmitter<any> = new EventEmitter();
    @Output() onClickContinue: EventEmitter<any> = new EventEmitter();
    @Output() logOutWithoutRedirect: EventEmitter<any> = new EventEmitter();
    sub: Subscription;
    ticks = 0;
    tempCounter: number;
    counterForCountdown: number = 100;

    constructor(private commonService: CommonService) {
        super();

    }

    timeCounter() {
        let timer = Observable.timer(1000, 1000);
        this.sub = timer.subscribe(t => this.tickerFunc(t));
        this.tempCounter = this.counterForCountdown;
    }

    tickerFunc(tick) {
        if (this.tempCounter - 1 > -1) {
            this.tempCounter = this.tempCounter - 1;
        } else {
            this.ngOnDestroy();
            this.logOutTimeRunOut = true;
            this.LogoutWithoutRedirect(event);
        }
    }

    startCounter() {
        this.timeCounter();
    }

    stopCounter() {
        this.sub.unsubscribe();
    }

    OnInit() {
        this.model = new IdleTimeOutModel();
    }

    public close(e: any) {
        //this.onClose.emit(e);
        this.hasTimeOut = false;
    }

    public ClickLogout(e: any) {
        try {
            SharedModel.page = SharedModel.home;
            this.onClickLogout.emit(e);
        } catch{
            this.commonService.redirect();
        }
    }

    public continueFlow(e: any) {
        this.onClickContinue.emit(e);
    }

    public LogoutWithoutRedirect(e: any) {
        this.logOutWithoutRedirect.emit(e);

    }

    public open() {
        this.hasTimeOut = true;
    }

    ngOnDestroy() {
        if (this.sub != undefined) {
            this.sub.unsubscribe();
        }
    }
}
